import React, { useEffect } from 'react';
import styles from './ExitModal.module.scss';
import classNames from 'classnames';
import { HEAP_EVENTS, track } from '../../utils/analytics';

interface ExitModalProps {
    onLeave: () => void;
    onStay: () => void;
    messagesSent: number;
}

export const ExitModal = (props: ExitModalProps) => {
    useEffect(() => {
        track({
            eventName: HEAP_EVENTS.ExitScreenView,
            eventData: {
                messagesSent: props.messagesSent,
            },
        });
    }, [props.messagesSent]);

    return (
        <div className={styles.root}>
            <div className={styles.modal}>
                <svg
                    className={styles.icon}
                    width="32"
                    height="32"
                    viewBox="0 0 32 32"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M1.3335 2.66699H20.0002V12.0003H17.3335V5.33366H4.00016V26.667H17.3335V20.0003H20.0002V29.3337H1.3335V2.66699Z"
                        fill="#161719"
                    />
                    <path
                        d="M22.672 11.7769L25.5621 14.667H6.66683V17.3337H25.5622L22.672 20.2238L24.5577 22.1094L30.6667 16.0004L24.5577 9.89128L22.672 11.7769Z"
                        fill="#161719"
                    />
                </svg>
                <div className={styles.content}>
                    <h2 className={styles.header}>Leaving the chat?</h2>
                    <p className={styles.description}>This conversation won't be saved</p>
                </div>
                <button
                    className={classNames(styles.button, styles.leaveCTA)}
                    onClick={props.onLeave}
                >
                    Leave
                </button>
                <button
                    className={classNames(styles.button, styles.stayCTA)}
                    onClick={props.onStay}
                >
                    Stay in the chat
                </button>
            </div>
        </div>
    );
};
